/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { IMaskInput } from "react-imask";
import PropTypes from "prop-types";

function InputMask(props) {
  const {
    ref,
    onChange,
    mask,
    showPlaceholder,
    prefix,
    blocks,
    isLazy,
    ...other
  } = props;

  const removeWhiteSpace = (val) => val.replace(/\s+/g, "");

  const onChangeHandler = (val) => {
    onChange({ target: { name: other.name, value: removeWhiteSpace(val) } });
  };

  const placeholderChar = showPlaceholder ? " " : undefined;

  return (
    <IMaskInput
      {...other}
      mask={mask}
      inputRef={ref}
      placeholderChar={other.placeholderChar ?? placeholderChar}
      lazy={isLazy ?? !showPlaceholder}
      unmask={prefix !== "preserveFormatting"}
      onAccept={onChangeHandler}
      {...(blocks && { blocks })}
    />
  );
}

export default InputMask;
InputMask.propTypes = {
  mask: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ test: PropTypes.func.isRequired }),
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  showPlaceholder: PropTypes.bool.isRequired,
};
